import { Directive, Host, Input, OnInit, TemplateRef } from '@angular/core';
import { FilterOutput } from '@app/shared/models/filter.interface';

export type BuildFilter = () => FilterOutput[];

@Directive({
  selector: '[vfsFilterBuilder]'
})
export class FilterBuilderDirective implements OnInit {
  @Input() buildFilter: BuildFilter;

  constructor(@Host() public parent: TemplateRef<any>) {}

  ngOnInit(): void {}
}
